import React, { useEffect, useState } from "react";
import Box from "@material-ui/core/Box";
import IconButton from "@material-ui/core/IconButton";
import SyncIcon from "@material-ui/icons/Sync";
import SyncDisabledIcon from "@material-ui/icons/SyncDisabled";
import { Fade, Paper, Popper, Typography } from "@material-ui/core";
import { format } from "date-fns";
import classNames from "classnames";
import SyncFooterStyles from "../styles/SyncFooter.styles";
import { useAppContext } from "../../../state/app/context";
import Alert from "../../../util/alert";

const SyncFooter = () => {
	const [syncTimeVisible, setSyncTimeVisible] = useState(false);
	const [firstTimeAlert, setFirstTimeAlert] = useState(true);
	const refPicker = React.useRef();

	const { state: appState } = useAppContext();
	const { timeSynced, syncError } = appState.currentEventSync() || {};
	const isSyncing = appState.isSyncing();

	useEffect(() => {
		setSyncTimeVisible(!!syncError);
		if (!firstTimeAlert) {
			Alert.sync(
				syncError ? "Remote sync failed" : "Remote sync reestablished",
				syncError
			);
		} else if (syncError !== undefined) {
			setFirstTimeAlert(false);
		}
	}, [syncError]);

	const classes = SyncFooterStyles({ syncError });

	return timeSynced ? (
		<Box className={classes.syncFooterBox}>
			<Popper
				open={syncTimeVisible}
				anchorEl={refPicker.current}
				placement="right"
				transition
				className={classes.tooltip}
			>
				{({ TransitionProps }) => (
					<Fade {...TransitionProps} timeout={350}>
						<Paper className={classes.paper}>
							<Typography className={classes.syncFooter}>
								<strong>Last synced: </strong>
								{format(
									new Date(timeSynced),
									"MM/dd/yyyy hh:mm:ss aaaaa'm'"
								)?.toUpperCase()}
							</Typography>
						</Paper>
					</Fade>
				)}
			</Popper>
			<IconButton
				ref={refPicker}
				aria-label={syncError ? "Sync failed, view details" : "View sync status"}
				onClick={() => {
					setSyncTimeVisible(!syncTimeVisible);
				}}
				className={classNames(classes.syncIconFooter, {
					[classes.syncIconSyncing]: isSyncing
				})}
			>
				{syncError ? <SyncDisabledIcon /> : <SyncIcon />}
			</IconButton>
		</Box>
	) : null;
};

export default SyncFooter;
